import React , { useState }from 'react';
//import '../../css/searchbar.css';
//import KeyBoardIcon from '../../images/keyboard.png';
import KeyBoardgrayIcon from '../../images/keyboardgray.png';
import {WordBookGroupBookChapter} from '../../../Classes/WordBookGroupBookChapter';
import Keyboard from '../modal/KeyBoard';
import Modal from 'react-bootstrap/Modal'

const SearchBodySearchBoxSearchBar = (props) => {
    
    //const [word,setWord] = useState(undefined);
    const [modalshow,setModalshow] = useState(false);
    //const [showInClass,setShowInClass] = useState(props.showInClass);
    const [selectionStart,setSelectionStart] = useState(0);
    const [selectionEnd,setSelectionEnd] = useState(0);

    const onSearchButtonClick = (event) =>{
        event.preventDefault();
        setModalshow(false);
        //console.log("OSBC:", props.word);

        if (props.word && props.word!=='')
        {
            var WGBC=new WordBookGroupBookChapter(  props.word.replaceAll('#','%23')
                                                                .replaceAll('*','{Star}')
                                                                .replaceAll('/','{Slash}')
                                                                .replaceAll('<','%2C')
                                                                .replaceAll('>','%2E')
                                                                .replaceAll('\\','{BackSlash}')
                                                                .trim()
                                                    ,props.selectedBookGroup
                                                    ,props.selectedBook
                                                    ,props.selectedChapter);
            //console.log('props.selectedBookGroup:',props.selectedBookGroup)                                                    
            //console.log("WGBC:",WGBC.Word+'/'+WGBC.BookGroup+'/'+WGBC.Book+'/'+WGBC.Chapter);
            props.onSearchButtonClick(WGBC);
        }
    }

    const onKeyboardButtonClick = (event) => {
        event.preventDefault();
        //console.log("KeyboardButtonPressed:",event.target.id);
        //console.log("S3:",this.state.selectionStart);
        //console.log("E3:",this.state.selectionEnd );

        window.location.href="#Head";
        if (!selectionStart)
        {
            setSelectionStart(event.target.selectionStart);
            setSelectionEnd(event.target.selectionStart);
        }
        setModalshow(!modalshow);
    }

    const onTextChange = (event) => {
        if (!modalshow)
        {
            setSelectionStart(event.target.selectionStart);
            setSelectionEnd(event.target.selectionEnd);
        }
        props.setWord(event.target.value);
    }

    const onTextKeyPress = (event) => {
        //console.log("OSBC:",event.nativeEvent.key);
        if ((event.nativeEvent.key === "Enter") && (props.word)) {
            event.preventDefault();
            onSearchButtonClick(event);
        }
        setSelectionStart(event.target.selectionStart);
        setSelectionEnd(event.target.selectionEnd);
        //console.log("S2:",this.state.selectionStart);
        //console.log("E2:",this.state.selectionEnd);
    }

    const onTextClick = (event) =>{
        setModalshow(false)
        setSelectionStart(event.target.selectionStart);
        setSelectionEnd(event.target.selectionEnd);
        //console.log("S:",event.target.selectionStart);
        //console.log("E:",event.target.selectionEnd );
    }

    const onVirtualKeyBoardTyped = (input) => {
        const inputed=  (
                            ((props.word) && (props.word.length>0))
                            ?
                            props.word.substring(0,selectionStart)
                            + input
                            + props.word.substring(selectionEnd,props.word.length)
                            :
                            input
                        )   
        setSelectionStart(selectionStart+input.length);
        setSelectionEnd(selectionStart+input.length);
        //console.log("S1:",selectionStart+input.length);
        //console.log("E1:",selectionStart+input.length);
        props.setWord(inputed);
        //console.log(props.word);
    }

    return (
        <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
            <form>
                <div className="divSearch">
                    <input 
                        id="word" 
                        type="text" 
                        className={props.word ? props.showInClass : "farsi"}
                        placeholder={props.placeHolder}
                        required="required" 
                        value={props.word || ''} 
                        onChange={onTextChange}
                        onKeyPress={onTextKeyPress}
                        onClick={onTextClick}
                        dir={(props.showInClass==="farsi" || props.showInClass==="Pahlavi" || props.showInClass==="Manavi")?"rtl":"ltr"}
                        autoComplete="off"
                    />
                    <input className="keyboard" type="image" alt="KB" src={KeyBoardgrayIcon} onClick={onKeyboardButtonClick} />
                </div>
                <div className="fullwidth_div">
                    <Modal
                        show={modalshow}
                        onHide={() => setModalshow(false)}
                        dialogClassName="modal-content-KB"
                        aria-labelledby="example-custom-modal-styling-title"
                        centered
                    >
                        <Modal.Body>
                            <Keyboard input={props.word} layout={props.showInClass} onVirtualKeyBoardTyped={onVirtualKeyBoardTyped}/>
                        </Modal.Body>
                    </Modal>
                    <input className="submit_button" type="submit" value={props.pageData.length!==0 && props.pageData[0].F29901!== undefined ? props.pageData[0].F29901:29901/*"جستجو"*/} onClick={onSearchButtonClick} />
                </div>
            </form>
        </div>
    );
}

export default SearchBodySearchBoxSearchBar;